import React, { useState } from "react";

const COLOR_POR_TIPO = {
  almacenamiento: "#00BFD6",
  picking: "#22c55e",
  recepcion: "#FF6A0D",
  embarque: "#800080",
  cuarentena: "#ef4444",
  devoluciones: "#c9af3a",
  produccion: "#556B2F",
  restringida: "#2C272A",
  otro: "#8a93a6",
};

//Sección del almacén (tipo React Flow "seccion"): un rectángulo de fondo que solo sirve para ubicar
//visualmente el área en el editor (no reemplaza a los nodos/conexiones, ver limitesVisuales en el modelo).
//react-flow-renderer 10.x no trae NodeResizer (se agregó en versiones más nuevas que no son compatibles
//con webpack 4 de este proyecto - ver conversación), así que el resize se hace a mano con un handle propio.
const SeccionCanvas = ({ data, selected }) => {
  const color = COLOR_POR_TIPO[data.tipo] || "#8a93a6";
  const [tamanoPreview, setTamanoPreview] = useState(null);

  const ancho = tamanoPreview?.width ?? data.anchoActual ?? 240;
  const alto = tamanoPreview?.height ?? data.altoActual ?? 200;

  const iniciarResize = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const inicioX = event.clientX;
    const inicioY = event.clientY;
    const anchoInicial = data.anchoActual ?? 240;
    const altoInicial = data.altoActual ?? 200;

    const mover = (moveEvent) => {
      const nuevoAncho = Math.max(80, anchoInicial + (moveEvent.clientX - inicioX));
      const nuevoAlto = Math.max(80, altoInicial + (moveEvent.clientY - inicioY));
      setTamanoPreview({ width: nuevoAncho, height: nuevoAlto });
    };
    const soltar = (upEvent) => {
      const nuevoAncho = Math.max(80, anchoInicial + (upEvent.clientX - inicioX));
      const nuevoAlto = Math.max(80, altoInicial + (upEvent.clientY - inicioY));
      document.removeEventListener("mousemove", mover);
      document.removeEventListener("mouseup", soltar);
      setTamanoPreview(null);
      data.onResize && data.onResize({ width: nuevoAncho, height: nuevoAlto });
    };
    document.addEventListener("mousemove", mover);
    document.addEventListener("mouseup", soltar);
  };

  return (
    <div
      style={{
        width: ancho,
        height: alto,
        background: `${color}12`,
        border: `2px ${data.bloqueada ? "dashed" : "solid"} ${selected ? color : color + "55"}`,
        borderRadius: 8,
        padding: 8,
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 700, color }}>
        {data.nombre} {data.bloqueada ? "(bloqueada)" : ""}
      </div>
      <div style={{ fontSize: 10, color: "#8a93a6" }}>{data.codigo}</div>
      {selected && (
        <div
          className="nodrag"
          onMouseDown={iniciarResize}
          style={{
            position: "absolute",
            right: 0,
            bottom: 0,
            width: 14,
            height: 14,
            cursor: "nwse-resize",
            background: color,
            borderRadius: "3px 0 3px 0",
          }}
        />
      )}
    </div>
  );
};

export default SeccionCanvas;
